export default __webpack_public_path__ + "static/media/25101701.cd4b3857.jpg";